module.exports = __webpack_public_path__ + "img/no-message0.fe22c9b0.png";